import { type IDatePickerService, type IGetDateDrawsUseCase, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for getting a datePicker containing a coupon.
 *
 * @param datePickerService DatePicker service dependency
 * @returns Use case executor for getting the date draws
 */
export function getDateDrawsUseCase(datePickerService: IDatePickerService): IGetDateDrawsUseCase {
  return {
    execute: async ({ product, year, month }): ReturnType<IGetDateDrawsUseCase['execute']> => {
      const dateResults = await datePickerService.getDateDrawsAsync(product, year, month);

      if (!dateResults) {
        throw new NotFoundError(`Date results for product ${product} on date ${year}-${month} not found`);
      }

      return dateResults;
    },
  };
}
